@if (segments && selected) {
  <div class="segmented-control mt-3">
    <div class="segmented-control-active-indicator" [style]="activeIndicatorStyle">&nbsp;</div>
    @for (segment of segments; track segment) {
      <div class="segmented-control-option"
        [class.segment-active]="segment?.value === selected"
        (click)="onChangeSegment(segment)">
        <div class="text-wrapper">
          <span>{{ $safeNavigationMigration(segment?.label) | translate }}</span>
          @if (segment?.hasEntries) {
            <!-- <span class="text-danger-700">*</span> -->
            <!-- <div class="dot-container">
            <i class="fa-regular fa-caret-down text-2xl text-tertiary-600"></i>
          </div> -->
        }
      </div>
    </div>
  }
</div>
}
